var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import TAnimation from '../../tquery.js';
var GlobalModal = /** @class */ (function () {
    function GlobalModal() {
        this.domClasses = {
            body: 'body',
            modal: '.js-modal-global',
            content: '.js-modal-content > *',
            closeBtn: '.js-modal-close',
            buttonsContainer: '.js-buttons-container',
            button: '.js-a-button',
            text: '.js-modal-text',
            circleIcon: '.a-icon-circle',
            formAction: '#modal-form',
        };
        this.dom = {};
        this.config = {
            buttons: [],
            removeElements: [],
            content: {
                html: '',
                text: '',
            },
            classes: {},
        };
        this.dom['body'] = document.querySelector(this.domClasses.body);
        this.dom['modal'] = document.querySelector(this.domClasses.modal);
        this.dom['content'] = document.querySelector(this.domClasses.content);
        this.dom['closeBtn'] = document.querySelector(this.domClasses.modal + ' ' + this.domClasses.closeBtn);
        this.dom['buttonsContainer'] = document.querySelector(this.domClasses.buttonsContainer);
        this.dom['button'] = document.querySelector(this.domClasses.modal + ' ' + this.domClasses.button);
        this.dom['text'] = document.querySelector(this.domClasses.text);
        this.dom['circleIcon'] = document.querySelector(this.domClasses.circleIcon);
        this.dom['formAction'] = document.querySelector(this.domClasses.formAction);
        this.modalAnimation = new TAnimation(this.dom['modal']);
    }
    GlobalModal.prototype.init = function () {
        this.showModal();
        this.removeElements();
        this.setCloseBtnAction();
        this.setSelectors();
        this.setButtons();
        this.setText();
    };
    GlobalModal.prototype.showModal = function () {
        this.modalAnimation.fadeIn();
    };
    GlobalModal.prototype.setConfig = function (config) {
        this.config = __assign(__assign({}, this.config), config);
        return this;
    };
    GlobalModal.prototype.removeElements = function () {
        var _this = this;
        this.config.removeElements.forEach(function (e) {
            _this.dom[e].remove();
        });
    };
    GlobalModal.prototype.setText = function () {
        if (this.config.content.html) {
            this.dom['text'].innerHTML = this.config.content.html;
        }
        else {
            this.dom['text'].textContent = this.config.content.text;
        }
    };
    GlobalModal.prototype.setCloseBtnAction = function () {
        var _this = this;
        this.dom['closeBtn'].addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.closeModal();
        });
    };
    GlobalModal.prototype.setSelectors = function () {
        for (var _i = 0, _a = Object.entries(this.config.classes); _i < _a.length; _i++) {
            var _b = _a[_i], element = _b[0], cl = _b[1];
            this.dom[element].classList.add(cl);
        }
    };
    GlobalModal.prototype.setButtons = function () {
        var _this = this;
        this.config.buttons.forEach(function (element) {
            var newButtonWrapper = _this.dom['button'].cloneNode(true);
            newButtonWrapper.classList.remove('hidden');
            var newButton = newButtonWrapper.querySelector('button');
            newButton.querySelector('.js-modal-button-text').textContent = element.text;
            if (element.actionUrl) {
                newButton.setAttribute('data-url', element.actionUrl);
            }
            if (element.actionPostUrl) {
                newButton.setAttribute('data-post-url', element.actionPostUrl);
            }
            if (element.e2e) {
                newButton.setAttribute('data-e2e', element.e2e);
            }
            if (element.isDeleteMethod) {
                newButton.setAttribute('is-delete-method', element.isDeleteMethod);
            }
            if (element.id) {
                newButton.setAttribute('id', element.id);
            }
            if (element.action) {
                newButton.setAttribute('data-action', element.action);
            }
            if (element.classList) {
                newButtonWrapper.classList = element.classList;
            }
            newButton.addEventListener('click', function (e) {
                var url = newButton.getAttribute('data-url');
                var postUrl = newButton.getAttribute('data-post-url');
                var action = newButton.getAttribute('data-action');
                if (url) {
                    window.location.pathname = url;
                }
                if (postUrl) {
                    var isDeleteMethod = newButton.getAttribute('is-delete-method');
                    if (isDeleteMethod) {
                        postUrl += '&_method=DELETE';
                    }
                    _this.dom['formAction'].action = postUrl;
                    _this.dom['formAction'].submit();
                }
                if (action) {
                    _this[action]();
                }
                if (element.callback) {
                    element.callback();
                }
            });
            _this.dom['buttonsContainer'].append(newButtonWrapper);
        });
    };
    GlobalModal.prototype.closeModal = function () {
        this.modalAnimation.fadeOut();
        this.dom['body'].style.overflow = 'auto';
        this.resetModal();
    };
    GlobalModal.prototype.resetModal = function () {
        var _this = this;
        setTimeout(function () {
            var button = _this.dom['buttonsContainer'].querySelector(_this.domClasses['button']);
            _this.dom['buttonsContainer'].innerHTML = '';
            _this.dom['buttonsContainer'].append(button);
            _this.config = {
                buttons: [],
                removeElements: [],
                content: {
                    html: '',
                    text: '',
                },
                classes: {},
            };
        }, 500);
    };
    return GlobalModal;
}());
export { GlobalModal };
